// extracted by mini-css-extract-plugin
module.exports = {"container":"Wrapper_container__4Kf0G","content":"Wrapper_content__19CB2","main":"Wrapper_main__3P8KN","floatingNavOverlay":"Wrapper_floatingNavOverlay__2TlgE"};